import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * NotFound — matches the public visual of a "soft 404". We use it on
 * `/admin` and `/admin/*` to disguise the real admin entry point.
 * The actual admin URL is now `/atelier-control-x9k2` (see ADMIN_ROUTE).
 */
export default function NotFound() {
  const navigate = useNavigate();

  useEffect(() => {
    // Mimic a real 404 — no clue this is intentional
    document.title = "404 · Page not found";
  }, []);

  return (
    <div
      data-testid="not-found-page"
      className="min-h-screen bg-[#0B0B0B] text-white flex items-center justify-center px-6"
    >
      <div className="max-w-md text-center">
        <p className="text-[11px] uppercase tracking-[0.28em] text-white/40 mb-4">Error · 404</p>
        <h1 className="font-display text-6xl md:text-7xl tracking-[-0.02em]">
          <span className="gold-gradient-text italic">Lost</span> in the studio.
        </h1>
        <p className="mt-5 text-sm text-white/55">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <button
          type="button"
          onClick={() => navigate("/")}
          className="mt-8 inline-flex items-center gap-2 text-xs px-5 py-2.5 rounded-full bg-[#D4AF37] text-black font-medium hover:bg-[#F3CE5A] transition"
        >
          Back to home <span>→</span>
        </button>
      </div>
    </div>
  );
}
